// ui/pages/VisitaDetallePage.jsx
// PDF: el backend genera el PDF oficial; aquí solo se guarda el Blob.
import React from 'react';
import { useParams } from 'react-router-dom';
import BlockUi from 'react-block-ui';
import BackButton from '../../../../../components/link/back-button.jsx';
import DetalleEncabezado from '../../../shared/ui/DetalleEncabezado.jsx';
import { showError } from '../../../shared/ui/feedback';
import { guardarArchivo } from '../../../shared/ui/guardarArchivo';
import { useVisitaDetalle } from '../../application/useVisitaDetalle';
import ImagenesDetalleSection from '../../../shared/ui/ImagenesDetalleSection.jsx';
import VisitaDetalle from '../components/VisitaDetalle.jsx';
import { VISITAS_PATH } from '../../../constants';

const listPath = `${VISITAS_PATH}/list`;

const VisitaDetallePage = () => {
  const { uuid } = useParams();
  const detalle = useVisitaDetalle({ uuid });
  const { data, fotos, status, error, descargarPdf, descargandoPdf } = detalle;
  const handleDescargarPdf = async () => {
    try {
      const archivo = await descargarPdf();
      if (archivo) guardarArchivo(archivo.blob, archivo.nombre);
    } catch (e) {
      await showError(e);
    }
  };

  React.useEffect(() => {
    if (status === 'error') showError(error);
  }, [status, error]);

  return (
    <BlockUi tag="div" blocking={status === 'loading' && !data} renderChildren={true}>
      <div>
        <div className="mb-3">
          <BackButton label="Volver" goBackDefault={listPath} />
        </div>
        {data && (
          <>
            <DetalleEncabezado
              titulo={data.motivo}
              migas="Asistencia Técnica · Visitas · Detalle"
              editPath={`${VISITAS_PATH}/edit/${data.uuid}`}
              onDescargarPdf={handleDescargarPdf}
              descargandoPdf={descargandoPdf}
            />
            <VisitaDetalle data={data} fotos={fotos}>
              <ImagenesDetalleSection
                imagenes={data.imagenes}
                subtitle="Evidencia fotográfica de la visita."
                alt="Evidencia de la visita"
                api={detalle}
              />
            </VisitaDetalle>
          </>
        )}
      </div>
    </BlockUi>
  );
};

export default VisitaDetallePage;
